//import { actualizarTienda } from "../services/putProductos";

export function mergeProductos(productosBase, productosFirebase) {
  const fbMap = new Map(productosFirebase.map((pf) => [pf.uid, pf]));

  return productosBase
    // primero filtramos: si existe en Firebase y tiene tienda=false, lo sacamos
    .filter((p) => {
      const datosFirebase = fbMap.get(p.uid);
      return !(datosFirebase && datosFirebase.tienda === false);
    })
    // luego hacemos el merge normal
    .map((p) => {
      const datosFirebase = fbMap.get(p.uid);
      if (datosFirebase) {
        return {
          ...p,
          precio: datosFirebase.oferta ? datosFirebase.precioOferta : datosFirebase.precio,
        };
      }
      return p;
    });
}

function reemplazarExtensionWebp(fileName) {
  if (!fileName) return "Imagen default limpi.webp"; // valor por defecto si no existe
  return fileName.replace(/\.[^/.]+$/, ".webp");
}

function convertirSaltosDeLinea(texto) {
  if (!texto) return "<p></p>";
  const conBr = texto.replace(/\n/g, "<br>");
  return `<p>${conBr}</p>`;
}

// Extrae el nombre de categoría en texto plano, sea que venga como string
// ("Varios") o como objeto crudo de Firebase ({ value, text: "Varios" }).
function extraerCategoria(categoria) {
  if (!categoria) return "Sin categoría";
  if (typeof categoria === "string") return categoria;
  return categoria.text || "Sin categoría";
}

// Convierte UN producto con la forma "cruda" de Firebase (fileName, precio
// como texto, categoria como objeto {value,text}, etc.) a la forma "plana"
// que usa el resto de la app (la misma forma que src/data.js).
function normalizarProductoFirebase(pf, id) {
  return {
    id,
    nombre: pf.nombre || "Sin nombre",
    categoria: extraerCategoria(pf.categoria),
    precio: pf.oferta ? pf.precioOferta : pf.precio,
    uid: pf.uid,
    url_img: reemplazarExtensionWebp(pf.fileName),
    descripcion: convertirSaltosDeLinea(pf.descripcion) || "",
  };
}

export function agregarSoloFirebase(productosBase, productosFirebase) {
  const baseUids = new Set(productosBase.map((p) => p.uid));

  // Filtrar los que están solo en Firebase y tienen tienda = true
  const soloFirebase = productosFirebase.filter(
    (pf) => pf.tienda === true && !baseUids.has(pf.uid)
  );

  // Calcular el id máximo actual
  const maxId = productosBase.reduce((max, p) => Math.max(max, p.id), 0);

  // Crear nuevos objetos con id incremental, normalizando la forma cruda
  const nuevosProductos = soloFirebase.map((pf, index) =>
    normalizarProductoFirebase(pf, maxId + index + 1)
  );

  // Agregar a productosBase
  const productosActualizados = [...productosBase, ...nuevosProductos];

  return { productosActualizados, nuevosProductos };
}
